import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import Loader from '../../loader';
import api from '../../api/apiClient';
import endpoints from '../../api/endpoints';
import { Button, DatePicker, Form, message, Modal, Tooltip } from 'antd';
import { ButtonBase, Radio, RadioGroup } from '@mui/material';
import { addCommaToNumber, getDecoded, getPercentage, timeAgo } from '../../util';
import CustomImage from '../../components/CommonComponents/CustomImage';
import CustomButton from '../../components/CommonComponents/CustomButton';
import config from '../../config';
import CustomInput2 from '../../components/CommonComponents/CustomInput2';
import CustomSelect from '../../components/CommonComponents/CustomSelect';
import dayjs from 'dayjs';
import CustomTable from '../../components/CommonComponents/CustomTable';

const {RangePicker} = DatePicker;

export default function UserDetail() {
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [date,setDate] = useState({startDate: "",endDate: ""});
  const [tableLoading, setTableLoding] = useState(false);
  const [trnx, setTrnx] = useState([]);
  const [totalTrnx, setTotalTrnx] = useState(0);
  const [totalCommission, setTotalCommission] = useState(0);
  const [trnxType, setTrnxType] = useState('all');
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const mounted = useRef(false);

  const routeParams = useParams();

  const getUserDetail = async () => {
    setLoading(true);
    const res = await api.get(endpoints.agent.userDetail + `?userId=`+ routeParams.userId);
    setLoading(false);
    if(res.code !== '200') return message.error(res.message);
    setUserInfo(res.data);
  }

  const getTrnx = async () => {
    setTableLoding(true);
    const res = await api.get(endpoints.agent.getUserTrnx + `?userId=${routeParams.userId}&startDate=${date.startDate}&endDate=${date.endDate}&type=${trnxType}&page=${page}`);
    setTableLoding(false);
    if(res.code !== '200') return message.error(res.message);
    setTrnx(res.data?.trnx);
    setTotalTrnx(res.data?.total?.totalTrnxRows);
    setTotalCommission(res.data?.total?.totalCommission);
  }

  const handleTrnxTypeChange = (value) => {
    setTrnxType(value);
    setPage(1);
  }

  const handleDateChange = (value, dateString) => {
    const startDate = dayjs(value[0]);
    const endDate = dayjs(value[1]);
    const diffInDays = endDate.diff(startDate, "day");

    if (diffInDays > 30) {
      message.error("The date range cannot exceed 30 days!");
      return;
    }

    setDate({startDate: dateString[0],endDate: dateString[1]});
    setPage(1);
  }

  useEffect(() => {
    if(!mounted.current) return;
    getTrnx();
  },[page, date, trnxType])

  useEffect(() => {
    mounted.current = true;
    const today = dayjs();
    const startDate = today.subtract(30, 'day').format('YYYY-MM-DD');
    const endDate = today.format('YYYY-MM-DD');
    setDate({ startDate: startDate, endDate: endDate });
    getUserDetail();
  },[]);

  const handleAdjust = async () => {
    const UI = () => {
      const [adjustLoading, setAdjustLoading] = useState(false);
      const handleFinish = async (values) => {
        console.log("values: ", values);
        let {amount, action } = values;
        amount = Number(amount);
        if(amount <= 0) return message.info("Amount must be greater than 0");
        setAdjustLoading(true);
        amount = Number(amount);
        if(action === "reduce") amount = -amount;
        const params = {
          userId: userInfo.user_id,
          amount: amount,
          reason: action === "add" ? "userDeposit" : "userWithdraw"
        }
        const res = await api.post(endpoints.agent.userAmountAdjust, params);
        setAdjustLoading(false);
        if(res.code !== "200") return message.error(res.message);
        message.success("Amount adjusted successfully");
        getUserDetail();
        Modal.destroyAll();
      }

      return (
        <Form
          name="basic"
          onFinish={handleFinish}
          autoCorrect='off'
          autoComplete="off"
          style={{marginTop: "1.5rem"}}
          initialValues={'add'}
        >
          <Form.Item
            name="action"
            style={{ padding: "0 0.4rem", color: "white" }}
            initialValue={"add"}
          >
          <RadioGroup defaultValue="add" style={{display: 'flex', flexDirection: "row"}}>
            <div><span>Deposit +</span><Radio value="add" style={{marginRight: "1rem"}}/></div>
            <div><span>Withdraw -</span><Radio  value="reduce">Reduce</Radio></div>
          </RadioGroup>
          </Form.Item>
          <Form.Item
            name="amount"
            rules={[
                {
                  required: true,
                  message: `Fill the amount!`,
                },
              ]}
          >
            <CustomInput2 number placeholder={"Amount..."}/>
          </Form.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              marginTop: "1rem",
            }}
          >
            <CustomButton
              type="submit"
              component="button"
              disabled={adjustLoading}
              style={{color: config.color.textColor}}
            >
              {adjustLoading ? <Loader/> : "Save"}
            </CustomButton>
          </div>

        </Form>
      )
    }
    Modal.confirm({
      title: "Adjust Amount",
      content: <UI/>,
      centered: true,
      cancelButtonProps: {style: {display: "none"}},
      okButtonProps: {style: {display: "none"}},
      closable: true,
      closeIcon: <i className="mdi mdi-close-thick" style={{fontSize: "18px", color: config.color.textColor}}></i>,
    });
  }

  const handleResetPassword = async () => {
    Modal.confirm({
      title: "Are you sure?",
      content: `Do you want to reset ${userInfo.name}'s password ?`,
      centered: true,
      closeIcon: <i className="mdi mdi-close-thick" style={{fontSize: "18px", color: config.color.textColor}}></i>,
      onOk: async () => {
        const params = {userId: userInfo.user_id}
        const res = await api.post(endpoints.agent.userResetPassword, params);
        if(res.code !== '200') return message.error(res.message);
        message.success(res.message);
      }
    });
  }

  const handleSuspend = () => {
    const action = userInfo.suspended == "1" ? "unsuspend" : 'suspend';
    Modal.confirm({
      title: "Are you sure?",
      content: `Do you want to ${action} ${userInfo.name} ?`,
      centered: true,
      closeIcon: <i className="mdi mdi-close-thick" style={{fontSize: "18px", color: config.color.textColor}}></i>,
      onOk: async () => {
        const params = {userId: userInfo.user_id, action}
        const res = await api.post(endpoints.agent.userSuspend, params);
        if(res.code !== '200') return message.error(res.message);
        getUserDetail();
        message.success(res.message);
      }
    });
  }

  const Header = () => {
    return (
      <div className='d-flex flex-column flex-md-row flex-lg-row align-items-start' style={{marginTop: "20px"}}>
           
        <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center align-items-lg-start'  style={{gap: "20px"}}>
          <div style={{display: 'flex'}}>
            <CustomImage src={userInfo.img} width={"150px"} height={"150px"} borderRadius={"75px"}/>
            {window.innerWidth < 500 && <div className='d-flex flex-column' style={{marginLeft: "60px"}}>
              <CustomButton onClick={handleSuspend} style={{borderColor: userInfo.suspended == "1" ? config.color.red : config.color.green, borderWidth: "1.5px", borderStyle: "solid"}}>
                {userInfo.suspended == "1" ? "Unsuspend" : "Suspend"}
              </CustomButton>
              <CustomButton onClick={handleAdjust} style={{marginTop: "10px", borderColor: config.color.yellow, borderWidth: "1.5px", borderStyle: "solid"}}>
                Adjust
              </CustomButton>
              {userInfo?.account_type === 'direct' &&
                <div style={{position: "relative"}}>
                  <CustomButton onClick={handleResetPassword} style={{marginTop: "10px", borderColor: "violet", borderWidth: "1.5px", borderStyle: "solid"}}>
                    Reset Password
                  </CustomButton>
                  <Tooltip title={"User's password will be reset to 123456"}>
                    <i className="mdi mdi-information-outline" style={{fontSize: "18px", position: "absolute", top: "15px", marginLeft: "5px"}}></i>
                  </Tooltip>
                </div>
                }        
            </div>}
          </div>
            
          <div className='d-flex flex-column' style={{height: "230px", justifyContent: 'space-evenly'}}>
              <div className='d-flex'>
                <h6 style={{width: "120px", color: config.color.textColor}}>User Id</h6>
                <h6 style={{width: "50px"}}>-</h6>
                <h6 style={{marginLeft: "5px", color: config.color.secondaryColor}}>{userInfo.user_id}</h6>
              </div>
              {userInfo?.account_type === 'direct' && <div className='d-flex'>
                <h6 style={{width: "120px",color: config.color.textColor}}>Account Name</h6>
                <h6 style={{width: "50px"}}>-</h6>
                <h6 style={{marginLeft: "5px", color: config.color.textColor}}>{userInfo.account_key}</h6>
              </div>}
              <div className='d-flex'>
                <h6 style={{width: "120px",color: config.color.textColor}}>Account Type</h6>
                <h6 style={{width: "50px"}}>-</h6>
                <h6 style={{marginLeft: "5px", color: config.color.textColor}}>{userInfo.account_type}</h6>
              </div>
              <div className='d-flex'>
                <h6 style={{width: "120px",color: config.color.textColor}}>Username</h6>
                <h6 style={{width: "50px"}}>-</h6>
                <h6 style={{marginLeft: "5px", color: config.color.textColor}}>{userInfo.name}</h6>
              </div>
              <div className='d-flex'>
                <h6 style={{width: "120px", color: config.color.textColor}}>Amount</h6>
                <h6 style={{width: "50px"}}>-</h6>
                <h6 style={{marginLeft: "5px", color: config.color.textColor}}>{addCommaToNumber(userInfo.amount || 0)}</h6>
              </div>
              <div className='d-flex'>
                <h6 style={{width: "120px", color: config.color.textColor}}>Suspend</h6>
                <h6 style={{width: "50px"}}>-</h6>
                <h6 style={{marginLeft: "5px", color: userInfo.suspended == '0' ? config.color.green : config.color.red}}>{userInfo.suspended == '0' ? 'false' : 'true'}</h6>
              </div>
              <div className='d-flex align-items-center'>
                <h6 style={{width: "120px", color: config.color.textColor,  marginBottom: 0}}>Created Date</h6>
                <h6 style={{width: "50px",marginBottom: 0}}>-</h6>
                <h6 style={{marginLeft: "5px", color: config.color.textColor, marginBottom: 0}}>{timeAgo(userInfo.created_date)}</h6>
              </div>
          </div>
        </div>
        {window.innerWidth > 500 && <div className='d-flex flex-column' style={{marginLeft: "60px"}}>
            <CustomButton onClick={handleSuspend} style={{borderColor: userInfo.suspended == "1" ? config.color.red : config.color.green, borderWidth: "1.5px", borderStyle: "solid"}}>
              {userInfo.suspended == "1" ? "Unsuspend" : "Suspend"}
            </CustomButton>
            <CustomButton onClick={handleAdjust} style={{marginTop: "10px", borderColor: config.color.yellow, borderWidth: "1.5px", borderStyle: "solid"}}>
              Adjust
            </CustomButton>
            {userInfo?.account_type === 'direct' &&
            <div style={{position: "relative"}}>
              <CustomButton onClick={handleResetPassword} style={{marginTop: "10px", borderColor: "violet", borderWidth: "1.5px", borderStyle: "solid"}}>
                Reset Password
              </CustomButton>
              <Tooltip title={"User's password will be reset to 123456"}>
                <i className="mdi mdi-information-outline" style={{fontSize: "18px", position: "absolute", top: "15px", marginLeft: "5px"}}></i>
              </Tooltip>
            </div>
            }
        </div>}
      </div>
    )
  }


  const Body = () => {

    const columns = [
      {
        title: "Reason",
        dataIndex: 'action',
        key: 'action',
      },
      {
        title: "id",
        key: 'action_ref',
        render: ({action, action_ref}) => {
          const handleIdClick = () => {
            if(action === 'purchase' || action === 'withdraw') return;
            navigate("/user/match/" + action_ref)
          }
          return <ButtonBase style={{textDecoration: action !== 'purchase' && action !== 'withdraw' ? "underline" : "none"}} onClick={handleIdClick}>{action_ref}</ButtonBase>
        }
      },
      {
        title: "Before",
        dataIndex: 'before_amount',
        key: 'before_amount',
      },
      {
        title: "Adjust",
        dataIndex: 'adjust_amount',
        key: 'adjust_amount',
      },
      {
        title: "After",
        dataIndex: 'after_amount',
        key: 'after_amount',
      },
      {
        title: "Date",
        dataIndex: 'logged_date',
        key: 'logged_date',
      },
    ];
    return (
      <div>
        <div style={{display: 'flex', gap: "20px", alignItems: "center", marginTop: "30px"}}>
          <RangePicker
            dropdownClassName={"createDateRangePicker"}
            style={{backgroundColor: "#2A3042", border: 0, color: config.color.textColor}}
            value={date.startDate ? [dayjs(date.startDate, 'YYYY-MM-DD'), dayjs(date.endDate, 'YYYY-MM-DD')] : ''}
            onChange={(v,dateString)=> handleDateChange(v,dateString)}
          />
          <CustomSelect
             defaultValue={trnxType}
             size='small'
             style={{width: "120px"}}
             onChange={handleTrnxTypeChange}
             options={[
              {value: 'all',label: "All"},
              {value: 'commission',label: "Commission"},
              {value: 'purchase',label: "Deposit"},
              {value: 'withdraw',label: "Withdraw"},
              {value: 'match',label: "Match"}
             ]}
          />
        </div>
        <div style={{marginTop: "20px"}}>
          <CustomTable
            rowHeight={13}
            data={trnx}
            columns={columns}
            loading={tableLoading}
            handlePageChange={(v) => setPage(v)}
            page={page}
            totalUsers={totalTrnx}
          />
        </div>
      </div>
    )
  }

  return (
    <div className='page-content'>
      {/* {loading && <Loader width='30px' height='30px'/>} */}
      {
        // !loading &&
        <div>
          <div style={{display: "flex",justifyContent: "space-between", alignItems: "center", marginRight: "20px"}}>
            <ButtonBase onClick={() => navigate(-1)} style={{fontStyle: "italic"}}><i className="mdi mdi-arrow-left-bold" style={{marginRight: "3px"}}></i> Back To List</ButtonBase>
            <div style={{display: 'flex', alignItems: "center"}}>
                <span style={{fontSize: "14px", width: "100px"}}>Commission</span>
                <span style={{width: "20px"}}>-</span>
                <span style={{fontSize: "16px", color: config.color.green}}>
                  {addCommaToNumber(Number(totalCommission))}<span style={{color: config.color.textColor}}>/</span><span style={{color: config.color.secondaryColor}}>{getPercentage(totalCommission,getDecoded().commission)}</span>
                </span>
            </div>
          </div>
          <Header/>
          <Body/>
        </div>
      }
    </div>
  )
}
